import type { TypographyProps } from '@mui/material';
import { Typography } from '@mui/material';

export const StepTitle = (props: TypographyProps) => (
  <Typography variant="h3" color="primary.dark" {...props} />
);
